import { forwardRef } from 'react'
import * as S from './styles'
import * as C from './constants'
import { TextAreaProps } from './type'

const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ onChange, id, value, scheme = C.WHITE, label, ...otherProps }, ref) => {
    return (
      <S.Wrapper>
        {label && (
          <S.Label scheme={C.LABELCOLORS[scheme]} htmlFor={id}>
            {label}
          </S.Label>
        )}
        <S.Textarea
          scheme={C.TEXTAREASCHEMAS[scheme]}
          id={id}
          value={value}
          onChange={({ target }) => onChange(target)}
          ref={ref}
          {...otherProps}
        />
      </S.Wrapper>
    )
  }
)

TextArea.displayName = 'TextArea'

export default TextArea
